import React from "react";
import { useFormContext, Controller } from "react-hook-form";

const InputField = ({ attribute }) => {
  const { name, className, ...rest } = attribute;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      {errors[name] && <p className="errorMesg">{errors[name].message}</p>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <input
            {...field}
            {...rest}
            className={`form-control px-3 py-2 ${
              errors[name] ? "error-red" : ""
            } ${className || ""}`}
          />
        )}
      />
    </div>
  );
};

export default InputField;
